export const TOOL_LABELS = {
  my_tasks: "My tasks",
  search_tasks: "Task search",
  upcoming_events: "Calendar",
  opportunities_summary: "Opportunities",
  team_directory: "Directory",
  attendance_and_leave: "Attendance & leave",
  marketplace_kpis: "Marketplace KPIs",
  notifications_recent: "Notifications",
};

export const SUGGESTIONS = {
  Founder: [
    "Give me today's marketplace snapshot",
    "Which tasks are overdue across the company?",
    "Summarise the opportunity pipeline",
    "Who is on leave or has pending leave requests?",
  ],
  Admin: [
    "Which tasks are overdue across the company?",
    "Summarise the opportunity pipeline",
    "Show pending leave requests",
    "What's on the company calendar this week?",
  ],
  Manager: [
    "How is my team's attendance this week?",
    "Which of my team's tasks are overdue?",
    "Pending leave requests in my department",
    "Opportunities with the nearest deadlines",
  ],
  Employee: [
    "What should I work on today?",
    "Show my overdue tasks",
    "What meetings do I have this week?",
    "Summarise my opportunities",
  ],
  Intern: [
    "What tasks are assigned to me?",
    "What's on my calendar this week?",
    "How has my attendance been this month?",
    "Who is in my department?",
  ],
};

export const MAX_MESSAGE_CHARS = 4000;
